import React, { useState, useEffect } from 'react';
import { API } from 'aws-amplify'
import '../App.css';
import picMac from '../assets/billy-simpsons2.png';
import picMark from '../assets/mark-simpsons2.png';

function AnnualStats(props) {

        const dataYear = props.queryYear
        const [picks2, setPicks2] = useState([])

        useEffect(() => {
                async function getFootball() {
                     let myInit = {
                         body:{
                             "Action": "getBets",
                             "year": Number(dataYear)
                         }
                     }
                     const apiData = await API.post ('buckluckyapi1', '/picks3', myInit)
                     console.log("RESPONSE",apiData)
                     console.log("YEAR",dataYear)
                     setPicks2(apiData)
                }
                getFootball()
            },[dataYear])
            
            let winPicksMark = 0
            let losePicksMark = 0
            let tiePicksMark = 0
            let winPicksMac = 0
            let losePicksMac = 0
            let tiePicksMac = 0
            let winningsMark = 0
            let winningsMac = 0
            picks2.forEach( pick => {
                if(pick.pick_user_id === 1){
                        if((Number(pick.score_picked_team) + (Number(pick.line_picked_team))) > pick.score_opposing_team){
                                winPicksMark = winPicksMark + 1
                                winningsMark = Number(winningsMark) + Number(pick.wager)
                                winningsMac = Number(winningsMac) - Number(pick.wager)
                        }else if((Number(pick.score_picked_team) + (Number(pick.line_picked_team))) < pick.score_opposing_team){
                                losePicksMark = losePicksMark + 1
                                winningsMark = Number(winningsMark) - Number(pick.wager)
                                winningsMac = Number(winningsMac) + Number(pick.wager)
                        }else{
                                tiePicksMark = tiePicksMark + 1
                        }
                }
                if(pick.pick_user_id === 2){
                        if((Number(pick.score_picked_team) + (Number(pick.line_picked_team))) > pick.score_opposing_team){
                                winPicksMac = winPicksMac + 1
                                winningsMark = Number(winningsMark) - Number(pick.wager)
                                winningsMac = Number(winningsMac) + Number(pick.wager)
                        }else if((Number(pick.score_picked_team) + (Number(pick.line_picked_team))) < pick.score_opposing_team){
                                losePicksMac = losePicksMac + 1
                                winningsMark = Number(winningsMark) + Number(pick.wager)
                                winningsMac = Number(winningsMac) - Number(pick.wager)
                        }else{
                                tiePicksMac = tiePicksMac + 1
                        }
                }
            })
            let winPercentMark = (Math.round(winPicksMark / (winPicksMark + losePicksMark) * 10000)/100).toFixed(2)
            let winPercentMac = (Math.round(winPicksMac / (winPicksMac + losePicksMac) * 10000)/100).toFixed(2)
            console.log("MARK",winPercentMark)
            console.log("MAC",winPercentMac)
        if(winningsMark >= winningsMac){
            return( 
            <div className="content">
                    <h2> {dataYear} Season</h2>
            <div className="voice1">
            
            <div className="playercontainer">
                    <div className="playerdiv">
                    <img src={picMark} alt="Player" className="playerPic" />
                    </div>
                    <div className="playerdivstats">
                    <span className="statbold">Player Stats:</span><br />
                    <span className="statbold">Mark {winPicksMark}-{losePicksMark}-{tiePicksMark}</span><br />
                    {dataYear} Pick Winner Percentage: {winPercentMark}%<br />
                    {dataYear} Picked Winners: {winPicksMark}<br />
                    {dataYear} Picked Losers: {losePicksMark}<br />
                    {dataYear} Picked Ties: {tiePicksMark}<br />
                    <div className="winnings">${winningsMark}</div>
                    </div>
            </div>

            <div className="playercontainer">
                    <div className="playerdiv">
                    <img src={picMac} alt="Player" className="playerPic" />
                    </div>
                    <div className="playerdivstats">
                    <span className="statbold">Player Stats:</span><br />
                    <span className="statbold">Bill {winPicksMac}-{losePicksMac}-{tiePicksMac}</span><br />
                    {dataYear} Pick Winner Percentage: {winPercentMac}%<br />
                    {dataYear} Picked Winners: {winPicksMac}<br />
                    {dataYear} Picked Losers: {losePicksMac}<br />
                    {dataYear} Picked Ties: {tiePicksMac}<br />
                    <div className="winnings">${winningsMac}</div>
                    </div>
            </div>
            <div className="clearall"></div>

            </div>
            </div>
            )
        }else{
            return( 
                <div className="content">
                        <h2> {dataYear} Season</h2>
                <div className="voice1">

                <div className="playercontainer">
                        <div className="playerdiv">
                        <img src={picMac} alt="Player" className="playerPic" />
                        </div>
                        <div className="playerdivstats">
                        <span className="statbold">Player Stats:</span><br />
                        <span className="statbold">Bill {winPicksMac}-{losePicksMac}-{tiePicksMac}</span><br />
                        {dataYear} Pick Winner Percentage: {winPercentMac}%<br />
                        {dataYear} Picked Winners: {winPicksMac}<br />
                        {dataYear} Picked Losers: {losePicksMac}<br />
                        {dataYear} Picked Ties: {tiePicksMac}<br />
                        <div className="winnings">${winningsMac}</div>
                        </div>
                </div>
                
                <div className="playercontainer">
                        <div className="playerdiv">
                        <img src={picMark} alt="Player" className="playerPic" />
                        </div>
                        <div className="playerdivstats">
                        <span className="statbold">Player Stats:</span><br />
                        <span className="statbold">Mark {winPicksMark}-{losePicksMark}-{tiePicksMark}</span><br />
                        {dataYear} Pick Winner Percentage: {winPercentMark}%<br />
                        {dataYear} Picked Winners: {winPicksMark}<br />
                        {dataYear} Picked Losers: {losePicksMark}<br />
                        {dataYear} Picked Ties: {tiePicksMark}<br />
                        <div className="winnings">${winningsMark}</div>
                        </div>
                </div>
                <div className="clearall"></div>
    
                </div>
                </div>
            )
        }
}

export default AnnualStats
